// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"4ff6bbf3","453":"014d3fd5","697":"19a12ce5","999":"eea28bcb"}[chunkId] + ".chunk.js";
};